<script setup lang="ts">
import { onMounted, ref } from "vue";

const nowLabel = ref("Current date/time yahan update hogi.");

onMounted(() => {
  nowLabel.value = new Date().toLocaleString("en-PK", {
    dateStyle: "medium",
    timeStyle: "short",
  });
});
</script>

<template>
  <section class="rounded-3xl border border-slate-200 bg-white p-5 shadow-sm">
    <div class="space-y-1">
      <h2 class="text-lg font-semibold text-slate-900">Aaj ki date aur time dekho</h2>
      <p class="text-sm text-slate-600">Yeh tool dikhata hai ke Python abhi ki date aur time kaise laata hai.</p>
    </div>

    <pre class="mt-4 overflow-x-auto rounded-2xl bg-slate-950 p-4 text-xs leading-6 text-slate-100"><code>import datetime
print(datetime.datetime.now())</code></pre>

    <div class="mt-4 rounded-2xl bg-amber-50 p-4 ring-1 ring-amber-100">
      <p class="text-xs font-semibold uppercase tracking-wide text-amber-700">Abhi ka example</p>
      <p class="mt-2 text-sm font-medium text-slate-900">{{ nowLabel }}</p>
    </div>
  </section>
</template>
